import { Typography } from 'antd';
import styled from 'styled-components';

const { Paragraph } = Typography;

export const Container = styled.div`
  width: 100%;
  max-width: 1484px;
  padding: 0 24px;
  margin: 0 auto;

  @media only screen and (max-width: 1440px) {
    max-width: 1440px;
  }

  @media only screen and (max-width: 992px) {
    padding: 0 16px;
  }
`;

export const Content = styled.div`
  padding: 32px 0 40px;
`;

export const StyledParagraph = styled(Paragraph)`
  && {
    line-height: 2.4;
    margin-bottom: 32px;
  }
`;

export const OrderedList = styled.ul`
  list-style: circle;
  padding-left: 24px;

  li {
    line-height: 2.2;
  }
`;
